import { ShutterProductType } from '../../constants/productTypes';
import { ProductBuilderMachineState } from '../../types';

type ShutterStatesByProductType = {
  [key in ShutterProductType]: ProductBuilderMachineState[];
};

export const allShutterStates: ProductBuilderMachineState[] = [
  'colour',
  'bladeSize',
  'fitting',
  // 'frameStyle',
  'operation',
  'measurements',
  // 'measureInsurance',
  'numberOfPanels',
  'panelConfiguration',
  'roomName',
  // 'shipping',
  'complete',
];

export const shutterStatesByProductType: ShutterStatesByProductType = {
  'Tecwood Plantation Shutter': allShutterStates,
};
